import * as React from 'react';
import { CurrentOS, OperatingSystems } from '../Constants/DataHelpers';

interface CountryCodeFlagProps {
	countryCode: string;
	title?: string;
	style?: any;
}

// offset between uppercase ascii and regional indicator symbols
const CharOffset = 127397;

export const CountryCodeFlag = (props : CountryCodeFlagProps) => {
	const useFallback = CurrentOS() === OperatingSystems.WIN;

	if(useFallback) {
		const flagUrl = `https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/${props.countryCode.toLowerCase()}.svg`;

		return (
			<img
				{...props}
				src={flagUrl}
				style={{
					display: 'inline-block',
					width: '1em',
					height: '1em',
					verticalAlign: 'middle',
					...props.style
				}}
				alt={props.title ?? 'Country Flag'}
			/>
		);
	}

	const emoji = props.countryCode.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + CharOffset));

	return (
		<span
			role="img"
			{...props}
			style={{
				display: 'inline-block',
				fontSize: '1em',
				lineHeight: '1em',
				verticalAlign: 'middle',
				...props.style
			}}
		>
		  {emoji}
		</span>
	);
};

export default CountryCodeFlag;
